import axios from '../javascript/custom-axios'
const V1 = '/v1'
const V2 = '/v2'
const RESOURCE_NAME = '/notification'

export default {
    sendNotification(identityNumber, key) {
        //return axios.get(`${V1}${RESOURCE_NAME}/SendNotificationWithIdentityNo?identityNumber=${identityNumber}&key=${key}`)
        return axios.post(`${V1}${RESOURCE_NAME}/SendNotificationWithIdentityNo?identityNumber=${identityNumber}&key=${key}`)
    },

    getNotification(page, pageSize, target, notificationType = '') {
        target = target ? target : this.$store.state.user.Id
        return axios.get(`${V2}${RESOURCE_NAME}?Target=${target}&Page=${page}&PageSize=${pageSize}&NotificationType=${notificationType}`)
    },

    readNotification(id) {
        return axios.put(`${V1}${RESOURCE_NAME}/readnotification?Id=${id}`)
    },

    readAllNotification(type = 'Individual') {
        return axios.put(`${V1}${RESOURCE_NAME}/ReadAllNotification/${type}`)
    },
}
